import React, { useEffect, useRef, useState } from 'react'

import config from 'environment'

import { store } from 'redux/store'
import { CollectionV2State } from 'redux/collectionV2/types'
import { SET_COLLECTION_V2_STATE } from 'redux/collectionV2/actions/types'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import { Keybind, basicKeybindSkips } from 'components/deckPage/modals/KeybindsOverlay'

import { copyCardNamesToClipboard } from 'utils/cardsToClipboard'
import { alpha } from 'redux/deck/helpers/sorting'

import styles from 'components/deckPage/modals/KeybindsOverlay/keybindsOverlay.module.scss'

const KeybindsOverlay = () => {
  const keylistener = useRef<(e: KeyboardEvent) => void>(() => null)

  const [open, setOpen] = useState(false)

  useEffect(() => {
    window.removeEventListener('keydown', keylistener.current)

    keylistener.current = (e: KeyboardEvent) => {
      const controlKey = config.getOnMac() ? e.metaKey : e.ctrlKey

      if (basicKeybindSkips(e)) return

      const state = store.getState()

      const ids = Object.keys(state.collectionV2.collectionCards)

      if (e.key === '?') setOpen(!open)

      if ((e.key === 'a' || e.key === 'A') && controlKey) {
        e.preventDefault()

        const payload: Partial<CollectionV2State> = {
          multiSelectedIds: ids.reduce((a, id) => ({ ...a, [`${id}`]: true }), {}),
        }

        store.dispatch({ type: SET_COLLECTION_V2_STATE, payload })
      }

      if ((controlKey && e.key === 'c') || e.key === 'C') {
        e.preventDefault()

        const multiSelectedIds = Object.keys(state.collectionV2.multiSelectedIds)
        const cards = Object.values(state.collectionV2.collectionCards)
        const selectedCards = cards
          .filter(collectionCard => multiSelectedIds.includes(`${collectionCard.id}`))
          .map(collectionCard => ({ ...collectionCard.card, qty: collectionCard.quantity }))
          .sort(alpha)

        copyCardNamesToClipboard(selectedCards, e.shiftKey)
      }
    }

    window.addEventListener('keydown', keylistener.current)

    return () => window.removeEventListener('keydown', keylistener.current)
  }, [open])

  return (
    <GlobalOverlayStack open={open} onClose={() => setOpen(false)} className={styles.container}>
      <h2>Collection Page Keybinds</h2>

      <div className={styles.content}>
        <div>
          <h4>Page Actions</h4>
          <Keybind keybind="?" description="Show/ hide keybinds" />
          <Keybind keybind="Ctrl + A" description="Select all cards" />
          <Keybind keybind="Ctrl + C" description="Copy selected cards" />
          <Keybind keybind="Ctrl + Shift + C" description="Copy selected cards (with qty)" />
        </div>

        {/*<h4>With multi-select active</h4>*/}
        {/*<Keybind keybind="Delete" description="Delete selected cards" />*/}

        <div>
          <h4>Card Actions</h4>
          <p>Actions that apply to the card in your collection that your cursor is hovering over</p>
          <Keybind keybind="Ctrl + Click" description="Start card multi-select" />
        </div>
      </div>
    </GlobalOverlayStack>
  )
}

export default KeybindsOverlay
